import React from 'react';
import styled from 'styled-components';
import LoadingIndicator from './LoadingIndicator';

const FULL_VH = document.documentElement.clientHeight;

const LoadingContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--sys-color--surface);
  height: ${({ headerHeight }) => FULL_VH - headerHeight}px;
  position: absolute;
  width: 100vw;
  padding-bottom: ${({ headerHeight }) => headerHeight}px;
  box-sizing: border-box;
`;

const LoadingPage = ({ headerHeight }: { headerHeight?: number }) => (
  <LoadingContainer headerHeight={headerHeight || 0}>
    <LoadingIndicator showContainer={true} />
  </LoadingContainer>
);

export default LoadingPage;
